import { Action, Selector, State, StateContext, createPropertySelectors } from '@ngxs/store';
import { inject, Injectable } from '@angular/core';
import { catchError, map, of } from 'rxjs';

import { IVenueResponse, IVenueStateModel } from './venue.models';
import { venueStateDefaults } from './venue.utils';
import { FetchVenue, FetchVenueSurfaceConfig } from './venue.actions';
import { VenueService } from './venue.service';

import { parseVenueSurfaceSvg, SPORT_URLS } from 'src/app/components/venue-surface/venue-surface.utils';
import { ISurfaceDimensions } from 'src/app/components/venue-surface/venue-surface.models';

@Injectable()
@State<IVenueStateModel>({
    name: venueStateDefaults.sliceName,
    defaults: venueStateDefaults.defaults
})
export class VenueState {
    private readonly _venueService = inject(VenueService);

    public static selectors = createPropertySelectors<IVenueStateModel>(VenueState);

    @Selector([VenueState.selectors.venue])
    public static venueSurfaceDimensions(venue: IVenueResponse | undefined): ISurfaceDimensions | undefined {
        if (!venue?.fieldOfPlay) {
            return;
        }

        return {
            length: venue.fieldOfPlay.playZoneLength,
            width: venue.fieldOfPlay.playZoneWidth
        };
    }

    @Action(FetchVenue)
    private _fetchVenue(ctx: StateContext<IVenueStateModel>, { gameId }: FetchVenue) {
        return this._venueService.getVenueById(gameId).pipe(
            map(venue => {
                return ctx.patchState({
                    venue
                });
            })
        );
    }

    @Action(FetchVenueSurfaceConfig)
    private _fetchVenueSurfaceConfig(ctx: StateContext<IVenueStateModel>, { sport }: FetchVenueSurfaceConfig) {
        const url = SPORT_URLS[sport];

        return this._venueService.getSportSurfaceSvg(url).pipe(
            map(svgText => {
                return ctx.patchState({
                    surfaceConfig: parseVenueSurfaceSvg(svgText, url),
                });
            }),
            catchError(err => {
                console.error(`Failed to dynamically load SVG config from ${url}:`, err);
                ctx.patchState({
                    surfaceConfig: undefined,
                });
                return of(undefined);
            })
        );
    }
}
